import { jsx as _jsx } from "react/jsx-runtime";
import { CatButton } from '@blocks-react/components/Button';
export const MyEquipmentButton = ({ children, ...buttonProps }) => _jsx(CatButton, { ...buttonProps, children: children });
